export default __webpack_public_path__ + "static/media/icon-saas-active.225d530e.svg";